<template>
  <div :class="`d-flex mt-2 ${isMensagemDoAtendente ? 'justify-end' : 'justify-start'}`">
    <audio
      v-if="anexo.contentType.startsWith('audio')"
      :src="anexo.url"
      controls
      style="min-width: 300px "
    />

    <img
      v-else-if="anexo.contentType.startsWith('image')"
      :src="anexo.url"
      style="
        max-height: 200px;
        max-width: 200px;
        object-fit: contain;
      "
    />

    <v-card
      v-else
      outlined
    >
      <v-card-text class="pa-3">
        Clique para baixar o arquivo:

        <a
          :href="anexo.url"
          target="_blank"
          download
        >
          {{ anexo.nome }}
        </a>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    anexo: {
      type: Object,
      required: true,
    },
    isMensagemDoAtendente: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
